













import { handleError } from "@/lib/api";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			username: '',
			password: '',
			message: ''
		}
	},
	methods: {
		async doLogin(){		
			try{
				
				await this.$store.dispatch('login', { username: this.username, password: this.password });
				this.$router.push('/');
			}catch(err){
				
				this.message = handleError(err);
				
			}
		}
	}
});
